import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v32.12.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import e from "@arcgis/core/Graphic";
import r from "@arcgis/core/geometry/Polygon";
import * as s from "@arcgis/core/geometry/geometryEngine";
import { ag as o } from "../api/rec.js";
import "uuid";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import "../index.js";
import "lodash";
import { b as t, G as n } from "../geometry/utils.js";
import { G as a } from "./map.js";

var ClassBreak = /*#__PURE__*/function () {
  function ClassBreak() {
    _classCallCheck(this, ClassBreak);
  }

  _createClass(ClassBreak, [{
    key: "rgbVals",
    get: function get() {
      return [Number(this.red), Number(this.green), Number(this.blue)];
    }
  }, {
    key: "rgbCssStr",
    get: function get() {
      return "rgb(".concat(this.rgbVals.join(","), ")");
    }
  }]);

  return ClassBreak;
}();

var addNullZoneClassBreak = function addNullZoneClassBreak(e) {
  var r = e.values().next().value,
      s = new Map(),
      o = new ClassBreak();
  o.classId = "1", o.red = o.green = o.blue = "128", o.label = "Other", o.heading = r.heading, s.set(null, o);

  var _iterator = _createForOfIteratorHelper(e),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          _t = _step$value[0],
          _n = _step$value[1];

      var _e = Number(_t) + 1;

      _n.classId = _e.toString(), s.set(_t, _n);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return s;
},
    classBreaksWithRecalculatedAcreage = function classBreaksWithRecalculatedAcreage(e, r) {
  var s = 0;

  var _iterator2 = _createForOfIteratorHelper(e),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          _o = _step2$value[0],
          _n2 = _step2$value[1];

      _n2.acreage = t.calculateArea(r[s]), e.set(_o, _n2), s++;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return e;
},
    clipZones = function clipZones(e, r) {
  var s = e.map(function (e) {
    return e.geometry;
  });
  clipZonesToField(s, r), clipZoneOverlaps(r);
},
    clipZoneOverlaps = function clipZoneOverlaps(e) {
  e.forEach(function (r, o) {
    for (var _n3 = o + 1; _n3 < e.length; _n3++) {
      if (s.intersects(e[_n3], r)) if (s.equals(e[_n3], r)) e.splice(_n3, 1);else {
        var _o2 = t.getSimplifiedPolygonParts(e[_n3]).map(function (e) {
          return s.difference(e, r);
        });

        e[_n3] = t.getCombinedBoundaries(_o2);
      }
    }
  });
},
    clipZonesToField = function clipZonesToField(e, o) {
  o.forEach(function (t, a) {
    var l = new r({
      spatialReference: t.spatialReference
    });
    e.forEach(function (e) {
      if (s.intersects(t, e)) {
        var _r = s.intersect(t, e);

        _r && (l = n.getCombinedBoundaries([l, _r]));
      }
    }), o[a] = l;
  });
},
    getResidualZone = function getResidualZone(e, r, o) {
  var n = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : .001;
  var a = s.union(r),
      l = t.removePolygonHolesSmallerThanThreshold(a),
      i = s.difference(e, l);
  var c = [],
      g = 0,
      u = !1;

  if (i) {
    var _a = t.getSimplifiedPolygonPartsThatExceedSizeThreshold(i, !1, n);

    if (_a) {
      var _n4 = r.flatMap(function (e) {
        return t.getPolygonParts(e);
      }),
          _l = mergeSlivers(_a, _n4, o);

      if (_l.length) {
        var _r2 = s.union(_l),
            _o3 = [_r2];

        clipZonesToField(t.getPolygonParts(e), _o3), _r2 = _o3[0], g = Number(t.calculateArea(_r2)), g > 0 && (c.push(_r2), u = !0);
      }
    }
  }

  return c.push.apply(c, _toConsumableArray(r)), {
    includeResidualAreaZone: u,
    updatedZones: c
  };
},
    mergeResidualZoneOrAddClassBreak = function mergeResidualZoneOrAddClassBreak(e, r) {
  var o = e.values().next().value;

  if (null === o.upperBound && null === o.lowerBound) {
    var _e2 = s.union(r.slice(0, 2));

    r = [_e2].concat(_toConsumableArray(r.slice(2)));
  } else e = addNullZoneClassBreak(e);

  return [e = classBreaksWithRecalculatedAcreage(e, r), r];
},
    mergeSlivers = function mergeSlivers(e, r, o) {
  return e.reduce(function (e, a) {
    if (t.isPolygonASliver(a, o)) {
      var _e3 = r.filter(function (e) {
        return !s.equals(e, a);
      }),
          _o4 = t.getLongestSharedBorder(a, _e3);

      if (_o4) {
        var _e4 = r.findIndex(function (e) {
          return n.areEqual(e, _o4);
        }),
            _s = t.mergePolygons(a, _o4);

        r.splice(_e4, 1, _s);
      } else console.warn("No merge candidate found for sliver polygon. The polygon will be discarded.");
    } else e.push(a);

    return e;
  }, []);
},
    processResidualAreaZoneForSurface = function processResidualAreaZoneForSurface(r, s, n) {
  return o([r], null, null, !0).then(function (r) {
    var _mergeResidualZoneOrA, _mergeResidualZoneOrA2;

    var o = r.map(function (r) {
      return new e({
        geometry: r.shape
      });
    }),
        a = t.getCombinedBoundaries(r.map(function (e) {
      return e.shape;
    })),
        l = t.calculateRawArea(a),
        i = _toConsumableArray(s.keys()),
        c = _toConsumableArray(s.values());

    clipZones(o, c);

    var _getResidualZone = getResidualZone(a, c, l),
        g = _getResidualZone.includeResidualAreaZone,
        u = _getResidualZone.updatedZones;

    g && (_mergeResidualZoneOrA = mergeResidualZoneOrAddClassBreak(n, u), _mergeResidualZoneOrA2 = _slicedToArray(_mergeResidualZoneOrA, 2), n = _mergeResidualZoneOrA2[0], u = _mergeResidualZoneOrA2[1], _mergeResidualZoneOrA);
    var m = new Map(),
        p = new Map();
    var d = 0;

    var _iterator3 = _createForOfIteratorHelper(n.values()),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _e5 = _step3.value;

        if (Number(_e5.acreage) > .01) {
          var _r3 = i.indexOf(_e5.classId);

          -1 === _r3 ? (m.set(_e5.classId, u[d]), p.set(_e5.classId, _e5)) : (m.set(_e5.classId, u[_r3]), p.set(_e5.classId, _e5)), d++;
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    return [p, m];
  });
},
    zoneIsWholeFieldZone = function zoneIsWholeFieldZone(e, r) {
  return e.length > 0 && s.equals(e[0].geometry, r.geometry);
};

var l = {
  addNullZoneClassBreak: addNullZoneClassBreak,
  classBreaksWithRecalculatedAcreage: classBreaksWithRecalculatedAcreage,
  clipZones: clipZones,
  clipZoneOverlaps: clipZoneOverlaps,
  clipZonesToField: clipZonesToField,
  cloneZones: function cloneZones(e) {
    return e.map(function (e) {
      return a.create(e.toJSON());
    });
  },
  entireFieldZoneIsMultiPart: function entireFieldZoneIsMultiPart(e, r) {
    return zoneIsWholeFieldZone(e, r[0]) && t.getSimplifiedPolygonParts(r[0].geometry).length > 1;
  },
  getOffset: function getOffset(e) {
    var r = 0,
        s = 0;
    return 0 === e ? s = 10 : -90 === e ? r = 10 : 180 === e ? (e = 0, s = -10) : 90 === e ? r = -10 : e < 0 && e > -90 ? (e *= -1, r = s = 10) : e < -90 ? (e = -1 * e + 180, r = 10, s = -10) : e > 0 && e < 90 ? (e = 360 - e, r = -10, s = 10) : e > 90 && (e = 180 - e, r = s = -10), {
      x: r,
      y: s,
      angle: e
    };
  },
  getResidualZone: getResidualZone,
  isMultipleMultiPartZones: function isMultipleMultiPartZones(e) {
    return e && e.length > 1 && e.some(function (e) {
      return t.getSimplifiedPolygonParts(e.geometry).length > 1;
    });
  },
  isSingleMultiPartZone: function isSingleMultiPartZone(e) {
    return 1 === e.length && t.getSimplifiedPolygonParts(e[0].geometry).length > 1;
  },
  mergeResidualZoneOrAddClassBreak: mergeResidualZoneOrAddClassBreak,
  mergeSlivers: mergeSlivers,
  processResidualAreaZoneForSurface: processResidualAreaZoneForSurface,
  oneZoneContainsCut: function oneZoneContainsCut(e, r) {
    var o = n.createPolyline(r);
    return e.some(function (e) {
      return n.polygonContainsAllPoints(e.geometry, r) && !s.intersects(o, n.getPolygonOutline(e.geometry));
    });
  },
  zoneIsWholeFieldZone: zoneIsWholeFieldZone,
  polygonIntersectsHole: function polygonIntersectsHole(e, o) {
    var n = o.map(function (e) {
      return new r({
        rings: e.geometry.rings,
        spatialReference: e.geometry.spatialReference.clone()
      });
    }),
        a = t.getAllHolesAsPolygons(n);
    var l = !1;
    return a.every(function (r) {
      if (s.intersects(e, r)) return l = !0, !1;
    }), l;
  }
};
export { ClassBreak as C, l as Z, addNullZoneClassBreak as a, clipZones as b, classBreaksWithRecalculatedAcreage as c, clipZoneOverlaps as d, clipZonesToField as e, mergeSlivers as f, getResidualZone as g, mergeResidualZoneOrAddClassBreak as m, processResidualAreaZoneForSurface as p };